// extracted by mini-css-extract-plugin
module.exports = {"main-component":"mentor_main-component__3hRkn"};